export default __webpack_public_path__ + "static/media/lostInTheNight.32721377.png";